import { ChannelMapperStrategyAbstract } from './channel-mapper-strategy.abstract'

export class NoopChannelMapperStrategyService extends ChannelMapperStrategyAbstract {
  public remapChannelNumber(_totalNumberOfChannels: number, channelNumber: number): number {
    return channelNumber
  }
}
